module.exports = __webpack_public_path__ + "img/pluginExtStep1.8330a7fd.jpg";